import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Het jojo-effect</title>
                <link rel="canonical" href={route("blogs.eighth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Je zult er weleens van gehoord hebben of misschien zelfs weleens zelf meegemaakt hebben. Iemand is heel veel kilo’s afgevallen in korte tijd, maar komt daarna ook heel snel deze kilo’s weer aan. Mensen willen zo snel mogelijk resultaat. Hierdoor gaan ze manieren zoeken om zoveel mogelijk in korte tijd af te kunnen vallen."
                />
                <meta
                    property="og:description"
                    content="Je zult er weleens van gehoord hebben of misschien zelfs weleens zelf meegemaakt hebben. Iemand is heel veel kilo’s afgevallen in korte tijd, maar komt daarna ook heel snel deze kilo’s weer aan. Mensen willen zo snel mogelijk resultaat. Hierdoor gaan ze manieren zoeken om zoveel mogelijk in korte tijd af te kunnen vallen."
                />
                <meta property="og:url" content={route("blogs.eighth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Het jojo-effect - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/het-jojo-effect.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/het-jojo-effect.webp"
                                    type="image/webp"
                                    alt="Het jojo effect"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/het-jojo-effect.jpg"
                                    type="image/jpeg"
                                    alt="Het jojo effect"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/het-jojo-effect.jpg"
                                    alt="Het jojo effect"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Het jojo-effect
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Je zult er weleens van gehoord hebben of misschien zelfs
                        weleens zelf meegemaakt hebben. Iemand is heel veel
                        kilo’s afgevallen in korte tijd, maar komt daarna ook
                        heel snel deze kilo’s weer aan. Mensen willen zo snel
                        mogelijk resultaat. Hierdoor gaan ze manieren zoeken om
                        zoveel mogelijk in korte tijd af te kunnen vallen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dat snelle afvallen en weer snel aankomen word ook
                        weleens aangeduid als het jojo-effect. Maar ligt dit
                        effect daadwerkelijk aan het snelle afvallen, of liggen
                        er andere redenen aan ten grondslag?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat gebeurt er tijdens het afvallen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je gaat afvallen zul je een calorietekort moeten
                        hanteren. Dit betekent dat je minder calorieën
                        binnenkrijgt dan je lichaam eigenlijk nodig heeft.
                        Hierdoor moet het lichaam de energie vanuit een ander
                        bron halen. Dit kan hij doen door vet te verbranden of
                        spieren af te breken.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens het afvallen gaat het lichaam zich ook aanpassen
                        naar het tekort. Dit betekent dat zogeheten
                        NEAT-processen (Non-Exercise Acitivity Thermogenesis)
                        naar beneden aangepast worden zodat het lichaam minder
                        energie verbruikt. Deze processen zijn niet essentieel
                        voor het lichaam. Dit proces word ook weleens de
                        spaarstand genoemd. Hierin verbruikt het lichaam zo
                        weinig mogelijk energie om het calorietekort te
                        compenseren.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De spaarstand bestaat dus echt. Uit onderzoek is
                        namelijk gebleken dat een groep mensen die heel veel
                        kilo’s waren afgevallen een veel lager onderhoudsniveau
                        in calorieën hadden dan een groep mensen die op al op
                        datzelfde gewicht zaten zonder af te vallen. Dit
                        verschil liep tot wel bijna 700 kcal. Dit betekende dus
                        dat de groep mensen die heel veel kilo’s waren
                        afgevallen veel minder mochten eten en/of moesten
                        bewegen om op gewicht te blijven dan de mensen die al op
                        dat gewicht waren. Dat is dus het effect van de
                        spaarstand van het lichaam.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je snel veel gewicht gaat verliezen zal het lichaam
                        ook sneller in deze spaarstand komen. Daardoor loop je
                        dus tegen muur aan, doordat je onderhoud dusdanig laag
                        word dat je heel veel moet doen om verder af te vallen
                        of überhaupt op gewicht te kunnen blijven. Op de lange
                        termijn zal dit voor de meeste personen niet vol te
                        houden zijn, waardoor zij ook weer veel kilo’s zullen
                        gaan aankomen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoeveel gewicht kan ik dan het beste afvallen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wij raden aan om ongeveer 0,5% á 1% lichaamsgewicht per
                        week af te vallen. Op het begin mag dit boven deze
                        percentages liggen, omdat er dan veel vochtverlies
                        optreed. Dit verlies heeft geen nadelige effecten op de
                        spaarstand zoals hierboven besproken. Na een paar weken
                        zal het gewichtsverlies dan tussen deze percentages
                        moeten liggen. Val je teveel af? Dan kun je het beste je
                        calorieën iets verhogen zodat je niet teveel gaat
                        afvallen. Val je te weinig af? Dan kun je je calorie
                        inname iets verlagen zodat je meer afvalt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Belangrijk daarbij is dat je je goed blijft voelen. Als
                        je merkt dat je weinig energie hebt kun je beter je
                        calorie inname iets verhogen zodat je wel blijft
                        afvallen, maar je er niet futlozer door gaat voelen.
                        Uiteindelijk is jezelf prettiger voelen voor de meeste
                        het echte hoofddoel en is afvallen daarvoor een middel.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
